<template>
    <div class="folder_page">
        <div class="top">
            <div class="back hand" @click="goBack"><v-icon>mdi-arrow-left</v-icon><span class="text">上一页</span></div>
        </div>
        <div class="center_tab_wrapper">
            <v-row>   
                <v-col class="space_menu menu1 d-md-none">
                    <v-tabs  
                    active-class="active"
                    background-color="accent-4"
                    :vertical="false">
                        <v-tab key="1">文件夹管理</v-tab>
                        <v-tab key="2">自定义字段管理</v-tab>
                        <v-tab key="3">回收站</v-tab>
                        <v-tab-item key="1">
                            <div class="common_tabs_wrapper" style="padding-top: 0;">
                                <div>
                                    <v-btn :dense="true">新建文件夹</v-btn>
                                </div>
                                <div class="space_right">
                                        <v-list dense>
                                            <v-list-item-group
                                            v-model="selectKeys"
                                            multiple
                                            color="primary">
                                                <div>
                                                    <foldTree :treeData="list" :spaceId="id"></foldTree>
                                                </div>
                                            </v-list-item-group>
                                        </v-list>
                                </div>
                            </div>
                        </v-tab-item>
                        <v-tab-item key="2">
                        </v-tab-item>
                        <v-tab-item key="3"></v-tab-item>
                    </v-tabs>
                </v-col>
                <v-col class="space_menu menu1 hidden-sm-and-down">
                    <v-tabs  
                    active-class="active"
                    background-color="accent-4"
                    :vertical="false">
                        <v-tab key="1">文件夹管理</v-tab>
                        <v-tab key="2">自定义字段管理</v-tab>
                        <v-tab key="3">回收站</v-tab>
                        <v-tab-item key="1">
                            <div class="common_tabs_wrapper" style="padding-top: 0;">
                                <div class="common_title margbsm margtsm">文件夹管理</div>
                                <div class="margbsm">
                                    <v-btn :dense="true"  @click="addFolder">新建文件夹</v-btn>
                                    <v-btn class="marl10" :dense="true" @click="batchDelFolder">删除文件夹</v-btn>
                                </div>
                                <div class="space_right" style="overflow-x:auto;">
                                        <v-list dense>
                                            <v-list-item-group
                                            v-model="selectKeys"
                                            multiple
                                            color="primary">
                                                <div>
                                                    <foldTree :treeData="list" :spaceId="id"></foldTree>
                                                </div>
                                            </v-list-item-group>
                                        </v-list>
                                </div>
                            </div>
                        </v-tab-item>
                        <v-tab-item key="2">
                            <div class="common_tabs_wrapper">
                                <div class="common_title margbsm">自定义字段管理</div>
                                <v-data-table
                                    dense
                                    :headers="headers"
                                    :items="data"
                                    item-key="name"
                                    class="elevation-1"
                                ></v-data-table>
                            </div>
                        </v-tab-item>
                        <v-tab-item key="3">
                            <div class="common_tabs_wrapper">
                                <div class="common_title margbsm">回收站管理</div>
                            </div>
                        </v-tab-item>
                    </v-tabs>
                </v-col>
            </v-row>
        </div>
        <v-dialog v-model="addVisible" width="500">
            <v-card>
            <v-card-title class="lighten-2">{{visibleTit}}</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
            <v-form>
                <v-container>
                <v-row>
                    <v-col
                    cols="12"
                    >
                    <div class="h36">
                        <v-text-field
                            v-model="form.name"
                            label="名称"
                            required
                            outlined
                            :dense="true"
                            placeholder="请输入名称"
                        ></v-text-field>
                    </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col
                    cols="12"
                    >
                    <div class="h36">
                        <v-text-field
                            v-model="form.description"
                            label="描述"
                            required
                            outlined
                            :dense="true"
                            placeholder="请输入描述"
                        ></v-text-field>
                    </div>
                    </v-col>
                </v-row>
                </v-container>
            </v-form>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                @click="handleAddCancel">
                取消
            </v-btn>
            <v-btn
                color="primary"
                @click="handleAddOk"
            >
                确定
            </v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import {mapActions} from 'vuex'
import Qs from 'qs'
import foldTree from '@/components/side/foldTree.vue'
export default {
    data() {
        return {
            id: '',
            addVisible: false,
            visibleTit: '',
            form: {},
            selectKeys: [],
            list: [],
            headers: [
                {
                    text: '字段名称',
                    align: 'start',
                    sortable: false,
                    value: 'name'
                },
                {
                    text: '字段类型',
                    align: 'start',
                    sortable: false,
                    value: 'description'
                },
                {
                    text: '字段选项',
                    align: 'start',
                    sortable: false,
                    value: 'docNumber'
                },
                {
                    text: '操作',
                    align: 'start',
                    sortable: false,
                    value: 'actions'
                },
            ],
            data: []
        }
    },
    components: {
        foldTree
    },
    created() {
        if(this.$route.query.spaceId) {
            this.id = parseInt(this.$route.query.spaceId)
            this.getList()
        }
    },
    computed: {
        isUpdate() {
            return this.$store.state.folderUpdate
        }
    },
    watch: {
        isUpdate(val) {
            if(val == 'update') {
                this.getList()
                this.$store.commit('setFolderUpdate','')
            }
        }
    },
    methods: {
        ...mapActions('folder',['folderList','folderSet','newFolder','delMulFolder']),
        goBack() {
            this.$router.go(-1)
        },
        successMsg(msg) {
            this.$message({
                type: 'success',
                message: msg || '操作成功!'
            })
        },
        failMsg(msg) {
            this.$message({
                type: 'error',
                message: msg || '操作失败!'
            })
        },
        warnMsg(msg) {
            this.$message({
                type: 'warning',
                message: msg
            })
        },
        getList() {
            let data = {
                params: {
                    workspaceId: this.id
                }
            }
            let _this = this
            this.folderSet({data: data,handle(res) {
                let list = res.folders
                list = list.filter((item)=>{
                    return item.level == 0
                })
                _this.list = list
            }})
        },
        addFolder() {
            this.form = {}
            this.visibleTit = '新建文件夹'
            this.addVisible = true
        },
        handleAddOk() {
            this.addVisible = false
            this.form.workspaceId = this.id
            let data = {
                params: this.form
            }
            let _this = this
            this.newFolder({data: data,handle(res) {
               if(res.success) {
                   _this.successMsg(res.message)
                   _this.getList()
               }else {
                   _this.failMsg(res.message)
               }
            }})
        },
        handleAddCancel() {
            this.addVisible = false
        },
        batchDelFolder() {
            if(this.selectKeys.length<=0) {
                this.warnMsg('请选择文件夹')
                return false
            }
            let data = {
                params: {
                    ids: this.selectKeys.join(',')
                }
            }
            let _this = this
            this.delMulFolder({data: data,handle(res) {
                if(res.success) {
                    _this.successMsg(res.message)
                    _this.getList()
                }else {
                   _this.failMsg(res.message) 
                }
            }})
        }
    }
}
</script>